const REGEX = {
  PASSWORD: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[^\w\s])[^\s]{8,20}$/g,
};

export default REGEX;
